import React from 'react';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const bonuses = [{
    title: 'Fichas de Especies Forestales',
    value: '$9.990',
    desc: 'Material visual listo para clase'
  }, {
    title: 'Planillas de Producción Forestal',
    value: '$7.990',
    desc: 'Seguimiento de cultivos y crecimiento'
  }, {
    title: 'Banco de Actividades Prácticas',
    value: '$9.990',
    desc: 'Aplicación directa en el aula'
  }, {
    title: 'Planificación Anual Forestal',
    value: '$7.990',
    desc: 'Todo el sistema organizado'
  }];
  return <section className="bg-[#0B1F17] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <h2 className="text-xl md:text-2xl font-black text-white text-center mb-3 uppercase tracking-tight" data-id="element-18">
          🎁 BONUS DE <span className="text-[#D4A843]" data-id="element-19">REGALO</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3 mb-4" data-id="element-20">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#102A1F] border border-[#74C69D] glow-neon rounded-lg p-3 relative overflow-hidden flex flex-col shadow-lg" data-id="element-21">
              <div className="absolute top-0 right-0 bg-[#D4A843] text-white text-[9px] font-black px-2 py-0.5 rounded-bl-lg z-10" data-id="element-22">
                #{i + 1}
              </div>
              <h3 className="text-xs md:text-sm font-black text-white mb-1 flex items-start gap-1.5 mt-1 leading-tight" data-id="element-23">
                <span className="text-[#D4A843]" data-id="element-24">🎁</span>
                <span data-id="element-25">{bonus.title}</span>
              </h3>
              <p className="text-[#BFC9C5] text-[10px] md:text-xs mb-2 ml-5" data-id="element-26">
                👉 {bonus.desc}
              </p>
              <div className="border-t border-[#1F3D2B] pt-1.5 flex justify-between items-center mt-auto" data-id="element-27">
                <span className="text-gray-500 line-through text-[10px] md:text-xs" data-id="element-28">
                  Valor: {bonus.value}
                </span>
                <span className="text-[#D4A843] font-black text-xs md:text-sm" data-id="element-29">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="max-w-sm mx-auto bg-[#102A1F] border-2 border-[#D4A843] rounded-xl p-3 text-center shadow-xl mb-4" data-id="element-30">
          <p className="text-[#BFC9C5] font-bold text-[10px] md:text-xs mb-0.5 uppercase tracking-wide" data-id="element-31">
            Valor total:
          </p>
          <p className="text-lg md:text-xl font-black text-gray-500 line-through mb-0.5" data-id="element-32">
            $35.960
          </p>
          <p className="text-xl md:text-3xl font-black text-[#D4A843] glow-gold inline-block" data-id="element-33">
            🔥 HOY: GRATIS
          </p>
        </div>

        <div className="flex justify-center" data-id="element-34">
          <CTAButton variant="primary" className="text-sm" data-id="element-35">
            QUIERO EL KIT + LOS BONUS
          </CTAButton>
        </div>
      </div>
    </section>;
}